<template>
<div class="page page_publishDZ">
    <!-- banner -->
    <div class="top_wrap">
        <img :src="publicPath+'statics/images/dingzhi/banner_publish.png'" alt="" class="banner">
    </div>
    <!-- 发布信息 -->
    <div class="xinxi">
        <div class="item">
            <div class="item_l">
                <!-- <span class="tag_required">*</span> -->
                <span class="">商品标题：</span>
            </div>
            <div class="item_r">
                <van-field v-model="title" placeholder="请填写商品标题" />
            </div>
        </div>
        <div class="item">
            <div class="item_l">
                <!-- <span class="tag_required">*</span> -->
                <span class="">商品类型：</span>
            </div>
            <div class="item_r" @click="show = true">
                <van-field v-model="cate" placeholder="请选择商品类型" readonly />
            </div>
        </div>
        <div class="item textarea">
            <div class="item_l">
                <span class="">商品描述：</span>
            </div>
            <div class="item_r">
                <van-field type="textarea" v-model="desc" placeholder="请填写描述信息" />
            </div>
        </div>
        <!-- 上传图片 -->
        <div class="uploadTu">
            <div class="title">上传图片</div>
            <div class="upload-images">
                <div class="img-box" v-for="(item, index) in imglist" :key="index">
                    <div class="icon-po">
                        <van-image :show-error="false" :show-loading="false" class="image" fit="contain" :src="imageUrl+item" />
                    </div>
                    <div class="del" @click="imgDel(index)"></div>
                </div>
                <van-uploader :after-read="onRead" accept multiple class="icon-add" ref="addPhone">
                    <div class="addPhone"></div>
                </van-uploader>
            </div>
        </div>
    </div>
    <!-- 发布 -->
    <div class="actions" @click="dingzhiFun">
        <div class="bottom_action">快捷定制</div>
    </div>
    <!-- 技艺弹层 -->
    <van-popup v-model="show" position="bottom">
        <van-picker show-toolbar :columns="skillList" value-key="name" @confirm="confirmSkill" @cancel="show = false;directTo=false"  />
    </van-popup>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: null,
            title: null,
            cate: null,
            desc: null,
            imglist: [], // 上传的图片
			show: false,
			skillList: [],
            cateId: null,
            directTo: false,
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '我要定制'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
        }
        this.getTradesmanSkill()
    },
    methods: {
        // 获取匠人技艺
        getTradesmanSkill() {
            var params = {
                token: this.token
            }
            this.$api.tradesman.skill(params).then(res => {
                if (res.code == 200) {
					this.skillList = res.result.list
                }
            })
		},
		// 选择技艺
		confirmSkill(val){
			this.cate = val.name
			this.cateId = val.id
            this.show = false
            if (this.directTo) {
                this.tijiao()
            }
		},
        // 上传图片
        onRead: function (file) {
            console.log("file");
            console.log(file);
            if ($.isArray(file)) {
                for (var i in file) {
                    this.$api.index.uploadImage({
                        imgFile: file[i].content
                    }).then(res => {
                        if (res.code == 200) {
                            this.imglist.push(res.result.url);
                        }
                    });
                }
            } else {
                this.$api.index.uploadImage({
                    imgFile: file.content
                }).then(res => {
                    if (res.code == 200) {
                        this.imglist.push(res.result.url);
                    }
                });
            }
        },
        // 删除图片
        imgDel(index) {
            this.imglist.splice(index, 1);
        },
		// 定制匠人
		dingzhiFun(){
			var that = this
			if(!that.cate){
                that.show = true
                that.directTo = true
				return 
			}else{
				that.tijiao()
			}
		},
		// 提交定制信息
		tijiao(){
			var params = {
				token: this.token,
				type: this.cateId
			}
			if(this.title){
				params.title = this.title
			}
			if(this.desc){
				params.describe = this.desc
			}
			if(this.imglist.length != 0){
				params.album = this.imglist.join()
			}
			console.log(params)
			this.$api.dingzhi.specialCreate(params).then(res=>{
				if(res.code == 200){
                    if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/dingzhi/tradesman?type='+res.result.type+'&dingzhiId='+res.result.id
                            }
                        }
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    } else {
                        this.$router.push({
                            path: '/dingzhi/tradesman',
                            query: {
                                type: res.result.type,
                                dingzhiId: res.result.id
                            }
                        })
                    }
				}
			})
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
